import namespace from '../../application/nm'
import EventEmitter from 'events'
import { appDispatcher } from '../../application/AppDispatcher'
import { getLastWordFromCamelCase } from '../../utils/string'
let { info, log, warn, error } = require('../../application/console')
import { create as makeEmptyObj, deepFreeze, classFactory } from '../../utils/object'

function addCurriedConsoleMethod(curriedMethods, method) {
  curriedMethods[method.methodName] = method.curry(`[${this.constructor.name}]`)
  return curriedMethods
}

function curryConsoleMethods(...consoleMethods) {
  // I have no idea why, but calling Array.from(...consoleMethods)
  // didn't work and Array.from(arguments) does.
  return Array.from(arguments).reduce(addCurriedConsoleMethod.bind(this), makeEmptyObj())
}

const CLASS_CONSTATNTS = deepFreeze({
  EVENTS: {
    CHANGE: 'change',
  },
})

export default class BaseStore extends EventEmitter {
  constructor(options) {
    super()
    this.state = makeEmptyObj()
    appDispatcher.register(this.routeAction.bind(this))

    this.merge(curryConsoleMethods.call(this, info, log, warn, error), { options })

    let { constructor } = this // eslint-disable-line no-shadow
    let className = constructor.name
    let baseClassNamePlural = `${getLastWordFromCamelCase(className)}s`
    let baseClassNamePluralLower = baseClassNamePlural.toLowerCase()
    // Register classes in namespace
    let classes = (namespace.classes = namespace.classes || makeEmptyObj())
    classes[baseClassNamePlural] = classes[baseClassNamePlural] || makeEmptyObj()
    classes[baseClassNamePlural][className] = constructor
    // Register instances in namespace
    let instances = (namespace.instances = namespace.instances || makeEmptyObj())
    instances[baseClassNamePluralLower] = instances[baseClassNamePluralLower] || new WeakSet()
    instances[baseClassNamePluralLower].add(this)
  }

  routeAction(action) {
    throw new Error('This method must be overridden by subclasses!', { action, context: this })
  }

  emitChange(payload) {
    // called in sub-classes by actions via this.routeAction.
    this.emit(this.constructor.EVENTS.CHANGE, payload)
    return this
  }

  addChangeListener(onChangeHandler) {
    // called by store consumers.
    this.on(this.constructor.EVENTS.CHANGE, onChangeHandler)
    return this
  }

  removeChangeListener(callback) {
    this.removeListener(this.constructor.EVENTS.CHANGE, callback)
    return this
  }

  static get EVENTS() {
    return CLASS_CONSTATNTS.EVENTS
  }

  merge(...sources) {
    Object.assign(this, ...sources)
    return this
  }

  static create(...args) {
    return classFactory(this).create(...args)
  }
}

export { BaseStore, appDispatcher }



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/baseStore.js